import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';

@Component({
    selector: 'app-fact',
    templateUrl: './fact.component.html',
    styleUrls: ['./fact.component.css'],
    standalone: false
})
export class FactComponent implements OnInit {
    @Input() detail;
    @Input() edit: Boolean;
    @Input() add: Boolean;
    @Input() hidetitle: Boolean;
    @Output() libelleNegocier = new EventEmitter<any>();

    listClient = [];
    listIndices = [];
    listPeriodes = [];
    listValeursIndices = [];
    error = '';
    dateDebut = '';
    dateFin = '';

    nePasRefactArt;
    nePasRefactPrest;

    @ViewChild('msg') msg;
    @ViewChild('dialogueListePeriode') dialogueListePeriode;
    @ViewChild('dialogueValeursIndices') dialogueValeursIndices;
    constructor(public common: CommonService, private modalService: BsModalService) { }

    ngOnInit() {
        this.nePasRefactArt = !this.detail['refactArt'];
        this.nePasRefactPrest = !this.detail['refactPrest'];
    }

    searchClient(event) {
        const param = 10;

        return this.common.appelComboK3Fct(param, event).then(datas => {
            if (this.common.verifySession(datas)) {
                this.listClient = datas.data;
            }
        });
    }

    showValeursIndices() {
        this.getListPeriodes().then(rvoid => {
            this.common.openModal(this.modalService, this.dialogueListePeriode);
        });
    }

    showDetail(rowPeriode) {
        this.getValeursIndices(rowPeriode);
    }

    getListPeriodes() {
        const param = {
            'servlet': 'DBIndiceGetListPeriodes',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'forcerSerialisation': 'true',
            'data': {
                'CLEF_CLIENT': {
                    'typeParam': 'int',
                    'valeur': this.detail.id || 0
                }
            }
        };

        return this.common.post('', { param: param }).then(datas => {
            if (datas.data) {
                this.listPeriodes = datas.data;
            } else {
                if (datas.message) {
                    this.error = datas.message;
                    this.common.openModal(this.modalService, this.msg);
                }
            }
        });
    }

    getValeursIndices(rowPeriode) {
        const param = {
            'servlet': 'DBIndiceGetValeurs',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'forcerSerialisation': 'true',
            'data': {
                'CLEF_CLIENT': {
                    'typeParam': 'int',
                    'valeur': this.detail.id || 0
                },
                'DATE_DEBUT': {
                    'typeParam': 'date',
                    'valeur': rowPeriode['dateDebut'].slice(0, -9)
                },
                'DATE_FIN': {
                    'typeParam': 'date',
                    'valeur': rowPeriode['dateFin'].slice(0, -9)
                }
            }
        };

        return this.common.post('', { param: param }).then(datas => {
            if (datas.data) {
                this.listValeursIndices = [];
                datas.data.forEach(vi => {
                    if (vi.chantier && vi.chantier.id) {
                        vi.chantier['libelleObjetEntite'] = (vi.chantier.numChantier ? vi.chantier.numChantier + '/' : '') +
                            (vi.chantier.responsable ? vi.chantier.responsable : '') +
                            (vi.chantier.ville ? '/' + vi.chantier.ville : '');
                    } else {
                        vi.chantier['libelleObjetEntite'] = 'Tous';
                    }

                    if (vi.agence && vi.agence.id) {

                    } else {
                        vi.agence['libelleObjetEntite'] = 'Tous';
                    }

                    this.listValeursIndices.push(vi);
                });

                this.parseDate(rowPeriode);
                this.common.openModalDmdEcoGED(this.modalService, this.dialogueValeursIndices);
            } else {
                if (datas.message) {
                    this.error = datas.message;
                    this.common.openModal(this.modalService, this.msg);
                }
            }
        });
    }

    parseDate(rowPeriode) {
        let dd = moment(rowPeriode['dateDebut'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        let df = moment(rowPeriode['dateFin'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        this.dateDebut = this.common.parseDate(dd);
        this.dateFin = this.common.parseDate(df);
    }

    changeDate(event, isFin?) {
        console.log(event)
        if (!isFin) {
            this.dateDebut = event;
        } else {
            this.dateFin = event;
        }
        console.log(this.dateDebut, this.dateFin)
    }

    saveValeursIndices() {
        if (!moment(this.dateDebut).isValid()) {
            this.error = 'Date de début invalide';
            this.common.openModal(this.modalService, this.msg);
            return;
        }

        if (!moment(this.dateFin).isValid()) {
            this.error = 'Date de fin invalide';
            this.common.openModal(this.modalService, this.msg);
            return;
        }

        const txtDebut = moment(this.dateDebut).format('DD/MM/YYYY');
        const txtFin = moment(this.dateFin).format('DD/MM/YYYY');
        this.listValeursIndices.forEach(vi => {
            vi['dateDebut'] = txtDebut;
            vi['dateFin'] = txtFin;
            vi['nomclass'] = 'ValeurIndice';
        });

        const param = {
            'servlet': 'DBIndiceSaveValeurs',
            'module': 'Recylog',
            'type': 'liste',
            'compression': 'false',
            'data': this.listValeursIndices
        };

        return this.common.post('', { param: param }).then(datas => {
            this.common.closeModal();
            this.getListPeriodes();
            return datas.data;
        });
    }

    ajouterPeriode() {
        this.detail['nomclass'] = 'Client';
        const param = {
            'servlet': 'DBIndiceGetListByClient',
            'module': 'Recylog',
            'type': 'objet',
            'compression': 'false',
            'forcerSerialisation': 'true',
            'data': this.detail
        };

        return this.common.post('', { param: param }).then(datas => {
            if (datas.data) {
                if (datas.data.length > 0) {
                    this.listIndices = datas.data;

                    let dd = moment().format('DD/MM/YYYY');
                    let df = moment().format('DD/MM/YYYY');
                    this.dateDebut = this.common.parseDate(dd);
                    this.dateFin = this.common.parseDate(df);
                    this.listIndices.forEach(vi => {
                        if (vi.chantier && vi.chantier.id) {
                            vi.chantier['libelleObjetEntite'] = (vi.chantier.numChantier ? vi.chantier.numChantier + '/' : '') +
                                (vi.chantier.responsable ? vi.chantier.responsable : '') +
                                (vi.chantier.ville ? '/' + vi.chantier.ville : '');
                        } else {
                            vi.chantier['libelleObjetEntite'] = 'Tous';
                        }

                        if (vi.agence && vi.agence.id) {

                        } else {
                            vi.agence['libelleObjetEntite'] = 'Tous';
                        }

                        this.listValeursIndices.push(vi);
                    });
                    this.common.openModalDmdEcoGED(this.modalService, this.dialogueValeursIndices);
                } else {
                    this.error = 'Il n\'y a pas de valeur d\'indice à définir!';
                    this.common.openModal(this.modalService, this.msg);
                }
            } else {
                if (datas.message) {
                    this.error = datas.message;
                    this.common.openModal(this.modalService, this.msg);
                }
            }
        });
    }

    showLibelleNego() {
        this.libelleNegocier.emit();
    }
}
